module.exports = __webpack_public_path__ + "img/title3.b39d094c.png";